<template>
    <template v-if="$zutil.pwaMobile()==1">
        <div>
            
        </div>
    </template>
    <template v-else-if="$zutil.pwaMobile() == 2">
        <div class="pkn-footer-v1">
            <div class="page-wrapper-portal" style="margin-bottom: 100px;">
                <div class="row pkn-footer-bottom">

                    <div class="col-md-6">
                        <div class="pkn-footer-copyright">Hak Cipta Terpelihara © 2022 oleh Kerajaan Negeri Kedah</div>
                    </div>

                    <div class="col-md-6">
                        <div class="pkn-footer-media-social">
                            <div class="pkn-fb"></div>
                            <div class="pkn-tiktok"></div>
                            <div class="pkn-statistik">Statistik Pengunjung Bulan ini : {{$page.props.pengunjung_bulan}} Jumlah Pengunjung : {{$page.props.pengunjung}}  </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </template>
    

    <template v-else>
        <div class="pkn-carian-landing pkn-carian-img">

            <!-- -->
            <div class="pkn-footer-menu pkn-icon " v-if="$page.props.auth.user.id == 0">
                <div class="page-wrapper-portal " v-if="cari_show == 1">

                    <div class="row col-md-12 pkn-carian-pop-up">
                        <div class="col-lg-4">
                        </div>
                        <div class="col-lg-3">

                                <div class="pkn-carian-title-1">Perkhidmatan Carian</div>

                        </div>
                        <div class="col-lg-5">

                            <!-- -->
                            <div class="row">
                                    <div class="col-12">

                                        <div class="input-group input-carian">
                                            <input type="text" class="form-control" placeholder="Sila Masukkan No. Hak Milik / No. Akaun / No. Bil " aria-label="Recipient's username" aria-describedby="button-addon2" v-model="no_rujukan">
                                            <button class="btn btn-pkn" type="button" @click="carian">Carian</button>
                                        </div>

                                    </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div class="pkn-icon-wrapper">
                    <section>
                        <div class="images-list">


                            <div class="pkn-icon">
                                <a href="#" style="text-decoration: none;" @click="mengenaiKami">
                                    <div class="">
                                        <img src="assets/images/icon/mengenai-kami.svg" alt="" class="thumb-lg">
                                    </div>
                                    <div class="pkn-carian-right-title-1">Mengenai Kami</div>
                                </a>
                            </div>

                            <!--
                            <div class="pkn-icon">
                                <a href="https://idaftar.kedah.gov.my/login.php?a=NTU4ODQw" style="text-decoration: none;">
                                    <div class="">
                                        <img src="assets/images/excavator.png" alt="" class="thumb-lg">
                                    </div>
                                    <div class="pkn-carian-right-title-1">Sistem</div>
                                    <div class="pkn-carian-right-title-2">iDaftar</div>
                                </a>
                            </div>


                            <div class="pkn-icon">
                                <a href="https://ipendaftaran.kedah.gov.my/" style="text-decoration: none;">
                                    <div class="">
                                        <img src="assets/images/blueprint.png" alt="" class="thumb-lg">
                                    </div>
                                    <div class="pkn-carian-right-title-1">Sistem</div>
                                    <div class="pkn-carian-right-title-2">iPendaftaran</div>
                                </a>
                            </div>


                            <div class="pkn-icon">
                                <a href="https://iforest.kedah.gov.my/permithutan/login.php?a=NzY3MDk0" style="text-decoration: none;">
                                    <div class="">
                                        <img src="assets/images/sustainable-energy.png" alt="" class="thumb-lg">
                                    </div>
                                    <div class="pkn-carian-right-title-1">Sistem</div>
                                    <div class="pkn-carian-right-title-2">iForest</div>
                                </a>
                            </div>
                        -->

                            <div class="pkn-icon">
                                <a href="#" style="text-decoration: none;" @click="dasarPrivasi">
                                    <div class="">
                                        <img src="assets/images/icon/dasar-privasi.svg" alt="" class="thumb-lg">
                                    </div>
                                    <div class="pkn-carian-right-title-1">Dasar Privasi</div>
                                </a>
                            </div>

                            <template v-if="$page.props.auth.user.id == 0">
                            <div class="pkn-icon">
                                <a href="#" style="text-decoration: none;" @click="formCari">
                                    <div class="">
                                        <img src="assets/images/icon/carian.svg" alt="" class="thumb-lg">
                                    </div>
                                    <div class="pkn-carian-right-title-1">Carian ibayaq</div>
                                </a>
                            </div>
                            </template>

                            <div class="pkn-icon">
                                <a href="#" style="text-decoration: none;" @click="aduan">
                                    <div class="">
                                        <img src="assets/images/icon/aduan.svg" alt="" class="thumb-lg">
                                    </div>
                                    <div class="pkn-carian-right-title-1">Aduan iBayaq</div>
                                </a>
                            </div>

                            <div class="pkn-icon">
                                <a href="#" style="text-decoration: none;" @click="pautanBerkaitan">
                                    <div class="">
                                        <img src="assets/images/icon/perkhidmatan-kami.svg" alt="" class="thumb-lg">
                                    </div>
                                    <div class="pkn-carian-right-title-1">Perkhidmatan Kami</div>
                                </a>
                            </div>

                            <div class="pkn-icon">
                                <a href="#" style="text-decoration: none;" @click="hubungiKami">
                                    <div class="">
                                        <img src="assets/images/icon/hubungi-kami.svg" alt="" class="thumb-lg">
                                    </div>
                                    <div class="pkn-carian-right-title-1">Hubungi Kami</div>
                                </a>
                            </div>

                        </div>
                    </section>
                </div>
                <!--/-->



                <!--
                <div class="col">
                    <inertia-link :href='$route("landing")' style="text-decoration: none;">
                        <div class="pkn-bg-icon">
                            <img src="assets/images/bank.png" alt="" class="thumb-lg">
                        </div>
                        <div class="pkn-carian-right-title-1">Laman  </div>
                        <div class="pkn-carian-right-title-2">Utama</div>
                    </inertia-link>
                </div>
                -->

                <!-- *
                <div class="col">
                    <a href="#" style="text-decoration: none;" @click="mengenaiKami">
                        <div class="">
                            <img src="assets/images/chat.png" alt="" class="thumb-lg">
                        </div>
                        <div class="pkn-carian-right-title-1">Mengenai</div>
                        <div class="pkn-carian-right-title-2">Kami</div>
                    </a>
                </div>
                <template v-if="$page.props.auth.user.id == 0">
                <div class="col">
                    <a href="https://idaftar.kedah.gov.my/login.php?a=NTU4ODQw" style="text-decoration: none;">
                        <div class="">
                            <img src="assets/images/excavator.png" alt="" class="thumb-lg">
                        </div>
                        <div class="pkn-carian-right-title-1">Sistem</div>
                        <div class="pkn-carian-right-title-2">iDaftar</div>
                    </a>
                </div>

                <div class="col">
                    <a href="https://ipendaftaran.kedah.gov.my/" style="text-decoration: none;">
                        <div class="">
                            <img src="assets/images/blueprint.png" alt="" class="thumb-lg">
                        </div>
                        <div class="pkn-carian-right-title-1">Sistem</div>
                        <div class="pkn-carian-right-title-2">iPendaftaran</div>
                    </a>
                </div>

                <div class="col">
                    <a href="https://iforest.kedah.gov.my/permithutan/login.php?a=NzY3MDk0" style="text-decoration: none;">
                        <div class="">
                            <img src="assets/images/sustainable-energy.png" alt="" class="thumb-lg">
                        </div>
                        <div class="pkn-carian-right-title-1">Sistem</div>
                        <div class="pkn-carian-right-title-2">iForest</div>
                    </a>
                </div>
                </template>

                <div class="col">
                    <a href="#" style="text-decoration: none;" @click="hubungiKami">
                        <div class="">
                            <img src="assets/images/sign-post.png" alt="" class="thumb-lg">
                        </div>
                        <div class="pkn-carian-right-title-1">Hubungi</div>
                        <div class="pkn-carian-right-title-2">Kami</div>
                    </a>
                </div>
                -->

                <!-- <div class="col">
                    <inertia-link :href='$route("landing")' style="text-decoration: none;">
                        <div class="">
                            <img src="assets/images/login.png" alt="" class="thumb-lg">
                        </div>
                        <div class="pkn-carian-right-title-1">Log</div>
                        <div class="pkn-carian-right-title-2">Masuk</div>
                    </inertia-link>
                </div> -->

                <!-- *
                <div class="col">
                    <a href="#" style="text-decoration: none;" @click="pautanBerkaitan">
                        <div class="">
                            <img src="assets/images/diagram.png" alt="" class="thumb-lg">
                        </div>
                        <div class="pkn-carian-right-title-1">Pautan</div>
                        <div class="pkn-carian-right-title-2">Berkaitan</div>
                    </a>
                </div>
                -->

                <!-- <div class="col">
                    <a href="#" style="text-decoration: none;" @click="daftar">
                        <div class="">
                            <img src="assets/images/approved.png" alt="" class="thumb-lg">
                        </div>
                        <div class="pkn-carian-right-title-1">Daftar</div>
                        <div class="pkn-carian-right-title-2">Pengguna</div>
                    </a>

                </div> -->

                <!--
                <template v-if="$page.props.auth.user.id == 0">
                <div class="col">
                    <a href="#" style="text-decoration: none;" @click="formCari">
                -->

                    <!-- <inertia-link :href='$route("landing.carian")+"?no_rujukan="' style="text-decoration: none;"> -->
                        <!--
                        <div class="">

                            <img src="assets/images/search-engine.png" alt="" class="thumb-lg">
                        </div>
                        <div class="pkn-carian-right-title-1">Carian</div>
                        <div class="pkn-carian-right-title-2">Perkhidmatan</div>
                        -->
                    <!-- </inertia-link> -->

                <!--
                    </a>
                </div>
                </template>
                -->
                <div class="pkn-footer-v1">
                    <div class="page-wrapper-portal">
                        <div class="row pkn-footer-bottom">

                            <div class="col-md-6">
                                <div class="pkn-footer-copyright text-left">Hak Cipta Terpelihara © 2022 oleh Kerajaan Negeri Kedah</div>
                            </div>

                            <div class="col-md-6">
                                <div class="pkn-footer-media-social">
                                    <div class="pkn-fb"></div>
                                    <div class="pkn-tiktok"></div>
                                    <div class="pkn-statistik">Statistik Pengunjung Bulan ini : {{$page.props.pengunjung_bulan}} Jumlah Pengunjung : {{$page.props.pengunjung}}  </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </div>

    </template>
    	







<w-dialog
    v-model="dialogMengenaiKami.show"
    :fullscreen="dialogMengenaiKami.fullscreen"
    :width="dialogMengenaiKami.width"
    :persistent="dialogMengenaiKami.persistent"
    :persistent-no-animation="dialogMengenaiKami.persistentNoAnimation"
    bg-color="trans"
    title-class="primary-light1--bg white" >
    <template #title class="font-square">
      <!-- <w-icon class="mr2">fal fa-pencil</w-icon>-->
      Mengenai Kami
    </template>
    <div class="page-wrapper-portal" style="color: white">
        <div class="row">
            <div class="col-6"><img class="img-fluid" :src="about_us_image" height="100%"></div>
            <div class="col-6">
                <div class="pkn-mengenai-logo"></div>
                <div v-html="about_us"></div>
            </div>
        </div>
    </div>

      <template #actions>
      <div class="spacer" />
      <w-button class="mr1" @click="dialogMengenaiKami.show = false">Tutup</w-button>
      </template>
</w-dialog>

<w-dialog
    v-model="dialogHubungiKami.show"
    :fullscreen="dialogHubungiKami.fullscreen"
    :width="dialogHubungiKami.width"
    :persistent="dialogHubungiKami.persistent"
    :persistent-no-animation="dialogHubungiKami.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <!-- <w-icon class="mr2">fal fa-pencil</w-icon> -->
      Hubungi Kami
    </template>
    <div class="page-wrapper-portal">

        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15867.53813456223!2d100.3724288!3d6.1462073!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2e9242a96bfb038!2sPejabat%20Kewangan%20dan%20Perbendaharaan%20Negeri%20Kedah!5e0!3m2!1sen!2smy!4v1652149478601!5m2!1sen!2smy" width="100%" height="350" style="border:1px solid #d2d2d2;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

        <div class="pkn-contact mt-2">
            <div class="row mt1">
                <div class="col-6">
                    <b>Pejabat Kewangan dan Perbendaharaan Negeri Kedah</b>,<br>
                    Aras 3, Blok E, Wisma Darul Aman,<br>
                    05503 Alor Setar, Kedah Darul Aman.
                </div>
                <div class="col-6">
                    <b>Phone</b> : +604 702 7901 / 7902 <br>
                    <b>email</b> : ibayaqaduan@kedah.gov.my <br>
                    <b>Whatsapp No.</b> : <a href="https://wa.link/8qbnji" target="_blank">04-7027571</a>
                </div>
            </div>
        </div>

    </div>
    <template #actions>
      <div class="spacer" />
      <w-button class="mr1" bg-color="grey-light5--bg" @click="dialogHubungiKami.show = false">Tutup</w-button>
      </template>
</w-dialog>

<w-dialog
    v-model="dialogAduan.show"
    :fullscreen="dialogAduan.fullscreen"
    :width="dialogAduan.width"
    :persistent="dialogAduan.persistent"
    :persistent-no-animation="dialogAduan.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <!-- <w-icon class="mr2">fal fa-pencil</w-icon> -->
      Aduan iBayaq
    </template>
    <div class="page-wrapper-portal">

        <template v-if="$zutil.mobile()== 1">
        <div class="pkn-contact">
                <w-form class="form-horizontal auth-form my-1"  ref="form" v-model="dialogAduan.valid" @validate="submitAduan">

                <div class="form-group mb-3">
                    <div class="input-group">
                          <div class="col-6">
                            <z-lookup class="w-100" style="margin-right: 15px;" label="Jabatan/Agensi" :url='service_utiliti+"api/lookup/jabatans"' :sort="false" :cache="false" v-model="form.lkp_jabatan_id" ></z-lookup><br>
                          </div>
                          <div class="col-6">
                            <z-lookup  class="w-100"  label="Klasifikasi" :url='service_utiliti+"api/lookup/aduan"' :sort="false" :cache="false" v-model="form.lkp_aduan_id" ></z-lookup>
                          </div>
                    </div>
                </div>

                <div class="form-group mb-3">
                    <div class="input-group">

                        <div class="col-6 mb-3">
                         <w-input  style="margin-right: 15px;" label=""  v-model="form.nama" name="nama" placeholder="Sila isi nama" :validators="[validators.required]">Nama<span class="pl2 darkblue">*</span>
                         </w-input>
                        </div>

                        <div class="col-6 mb-3">
                         <w-input style="margin-right: 15px;" label="" type="email"  v-model="form.emel" name="email" placeholder="Sila isi emel" :validators="[validators.required, validators.email]">Emel<span class="pl2 darkblue">*</span>
                         </w-input>
                        </div>
                        
                        <div class="col-6 mb-3">
                         <w-input label="" type="text"  v-model="form.no_telefon" name="no_telefon" placeholder="Sila isi no telefon" :validators="[validators.required]">No Telefon<span class="pl2 darkblue">*</span></w-input>
                        </div>

                    </div>
                </div>

                <div class="form-group mb-3">
                    <div class="input-group">
                          <w-textarea class="xs3 mr3" v-model="form.keterangan" name="keterangan" placeholder="Sila Nyatakan Aduan / Penghargaan / Pertanyaan / Cadangan">Catatan<span class="pl2 darkblue">*</span></w-textarea>
                    </div>
                </div>

                <div class="form-group mb-3">
                    <div class="input-group">
                          <w-input class="xs3 mr3" type="file" placeholder="Tiada Fail Dipilih" v-model="files" label="">Sila Muatnaik Gambar/Fail</w-input>
                    </div>
                </div>

                </w-form>
                <w-button
                        type="submit"
                        class="ml1"
                        @click="$refs.form.validate()"
                    >
                        Hantar Aduan
                </w-button>

        </div>

      </template>
      <template v-else>
        <div class="pkn-contact">
                <w-form class="form-horizontal auth-form my-1"  ref="form" v-model="dialogAduan.valid" @validate="submitAduan">

                <div class="form-group mb-3">
                    <div class="input-group">
                        <w-flex class="mt2">

                            <div class="col-6">
                            <z-lookup style="margin-right: 15px;" label="Jabatan/Agensi" :url='service_utiliti+"api/lookup/jabatans"' :sort="false" :cache="false" v-model="form.lkp_jabatan_id" ></z-lookup>
                            </div>

                            <div class="col-6">
                            <z-lookup  label="Klasifikasi" :url='service_utiliti+"api/lookup/aduan"' :sort="false" :cache="false" v-model="form.lkp_aduan_id" ></z-lookup>
                            </div>

                        </w-flex>
                    </div>
                </div>

                <div class="form-group mb-3">
                    <div class="input-group">

                        <div class="col-4">
                         <w-input  style="margin-right: 15px;" label=""  v-model="form.nama" name="nama" placeholder="Sila isi nama" :validators="[validators.required]">Nama<span class="pl2 darkblue">*</span>
                         </w-input>
                        </div>

                        <div class="col-4">
                         <w-input style="margin-right: 15px;" label="" type="email"  v-model="form.emel" name="email" placeholder="Sila isi emel" :validators="[validators.required, validators.email]">Emel<span class="pl2 darkblue">*</span>
                         </w-input>
                        </div>

                        <div class="col-4">
                         <w-input label="" type="text"  v-model="form.no_telefon" name="no_telefon" placeholder="Sila isi no telefon" :validators="[validators.required]">No Telefon<span class="pl2 darkblue">*</span></w-input>
                        </div>

                    </div>
                </div>

                <div class="form-group mb-3">
                    <div class="input-group">
                          <w-textarea class="xs3 mr3" no-autogrow resizable v-model="form.keterangan" name="keterangan" placeholder="Sila Nyatakan Aduan / Penghargaan / Pertanyaan / Cadangan" rows="1">Catatan<span class="pl2 darkblue">*</span></w-textarea>
                    </div>
                </div>

                <div class="form-group mb-3">
                    <div class="input-group">
                          <w-input class="xs3 mr3" type="file" placeholder="Tiada Fail Dipilih" v-model="files" label="">Sila Muatnaik Gambar/Fail</w-input>
                    </div>
                </div>

                </w-form>
                <w-button
                        type="submit"
                        class="ml1"
                        @click="$refs.form.validate()"
                    >
                        Hantar Aduan
                </w-button>

        </div>
      </template>


    </div>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="tutup()">Tutup</w-button>
      </template>
</w-dialog>

<w-dialog
    v-model="dialogDasarPrivasi.show"
    :fullscreen="dialogDasarPrivasi.fullscreen"
    :width="dialogDasarPrivasi.width"
    :persistent="dialogDasarPrivasi.persistent"
    :persistent-no-animation="dialogDasarPrivasi.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <!-- <w-icon class="mr2">fal fa-pencil</w-icon> -->
      Dasar Privasi
    </template>
    <div class="page-wrapper-portal card-scroll">

        <!-- -->
        <div class="row">
            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" @click="pilihBerkaitan(1)">
                    <b> PENAFIAN </b>
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample" v-if="berkaitan == 1">
                  <div class="accordion-body">

                    Pihak Kerajaan Negeri Kedah tidak bertanggungjawab terhadap sebarang kehilangan atau kerosakan yang dialami semasa menggunakan maklumat dalam laman ini.

                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" @click="pilihBerkaitan(2)">
                    <b>DASAR PRIVASI</b>
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingTwo" data-bs-parent="#accordionExample" v-if="berkaitan == 2">
                  <div class="accordion-body">

                    <ul>
                        <li>
                            Pihak Kerajaan Negeri mengumpul maklumat apabila anda mendaftar di portal. Semasa pendaftaran di portal iBAYAQ, anda akan diminta untuk memasukkan nombor kad pengenalan, alamat e-mel, alamat atau nombor telefon.
                        </li>
                        <li>
                            Alamat e-mel yang anda berikan untuk pemprosesan, hanya akan digunakan untuk menghantar notifikasi, resit dan maklumat yang berkaitan dengan pembayaran anda.
                        </li>
                        <li>
                            Pihak Kerajaan Negeri melaksanakan yang untuk menjaga keselamatan maklumat peribadi anda apabila anda memasuki, menghantar atau mengakses maklumat.
                        </li>
                        <li>
                            Pihak Kerajaan Negeri menawarkan penggunaan komputer pelayan yang selamat. Semua maklumat sensitif yang dibekal akan dihantar melalui teknologi Secure Socket Layer (SSL) yang hanya boleh dicapai oleh individu yang diberikan kuasa dengan hak capaian khas.
                        </li>
                        <li>
                            Selepas tamat transaksi, maklumat peribadi anda disimpan pada komputer pelayan Pihak Kerajaan Negeri.
                        </li>
                        <li>
                            Portal iBAYAQ menggunakan teknologi terkini termasuk penyulitan perisian untuk melindungi maklumat anda atau mana-mana data yang anda berikan dalam portal bagi mengekalkan standard keselamatan untuk menghalang capaian yang tidak dibenarkan.
                        </li>
                        <li>
                            Pihak Kerajaan Negeri tidak menjual, memperdagang ataupun memindahkan maklumat peribadi anda kepada pihak luar. Ini tidak termasuk pihak ketiga (jika ada) yang membantu kami dalam mengendalikan portal iBAYAQ.
                        </li>
                        <li>
                            Pihak Kerajaan Negeri juga boleh mengeluarkan maklumat anda apabila kami percaya pengeluaran data tersebut sesuai dan mematuhi undang-undang.

                        </li>
                        <li>
                            Untuk melindungi data peribadi anda, semua storan elektronik dan penghantaran maklumat akaun pengguna disimpan dengan menggunakan teknologi keselamatan yang terkini.
                        </li>
                        <li>
                            Dasar Privasi dalam talian ini digunakan hanya kepada maklumat yang dikumpulkan melalui portal iBAYAQ dan tidak kepada maklumat yang dikumpul di luar talian.
                        </li>
                        <li>
                            Dengan menggunakan portal iBAYAQ anda bersetuju dengan dasar privasi portal Pihak Kerajaan Negeri.
                        </li>
                        <li>
                            Pihak Kerajaan Negeri mempunyai hak untuk mengubah polisi privasi portal iBAYAQ dan akan menyiarkan perubahan tersebut pada laman ini.
                        </li>
                        <li>
                            Jika terdapat sebarang soalan mengenai dasar privasi ini, anda boleh menghubungi Pihak Kerajaan Negeri menggunakan maklumat di bawah:
                        </li>
                    </ul>

                    <ul class="no-bullets">

                        <li>

                            <b>Pejabat Kewangan dan Perbendaharaan Negeri Kedah</b>,<br> <br>
                            Aras 3, Blok E Wisma Darul Aman, <br>
                            05350 ALor Setar,<br>
                            Kedah Darul Aman<br><br>

                        </li>
                        <li><b>Tel :</b> 04-7027795 / 04-7027796 | <b>Emel :</b> ibayaq@kedah.gov.my</li>

                    </ul>

                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" @click="pilihBerkaitan(3)">
                    <b> TERMA DAN SYARAT </b>
                  </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree" data-bs-parent="#accordionExample" v-if="berkaitan == 3">
                  <div class="accordion-body">

                    Sekiranya anda mengakses portal iBAYAQ ini, anda mengakui dan bersetuju bahawa terma-terma dan syarat-syarat yang mengikat anda merupakan satu perjanjian diantara anda sebagai pengguna, dengan Pihak Kerajaan Negeri Kedah. <br><br>

                    Semua pembayaran adalah tertakluk kepada syarat-syarat berikut: <br><br>

                    <ul>
                        <li>
                    Semua jumlah dinyatakan ialah dalam MYR - Malaysia Ringgit.
                        </li>
                        <li>

                    Pihak Kerajaan Negeri Kedah tidak akan menerima sebarang liabiliti bagi bayaran yang tidak diterima oleh akaun agensi yang betul jika anda memasukkan nombor akaun yang tidak betul atau butiran peribadi yang tidak tepat. Kami juga tidak akan menerima sebarang liabiliti jika bayaran anda tidak dibenarkan atau ditolak.
                        </li>
                        <li>
                    Anda akan menerima pengesahan bayaran pada skrin dan juga emel selepas membuat pembayaran. Anda boleh mencetak bukti pembayaran apabila transaksi telah selesai (berjaya).
                        </li>
                        <li>
                    Resit pembayaran yang dicetak adalah sah diperlakukan untuk sebarang urusan rasmi.
                        </li>
                        <li>
                    Sekiranya anda mempunyai sebarang pertanyaan mengenai bayaran berlebihan dan layak untuk menuntut bayaran balik, sila hubungi agensi/jabatan berkaitan.
                        </li>
                        <li>
                    Semua butir-butir pembayaran yang dimasukkan melalui portal iBAYAQ ini adalah disulitkan (encrypted) apabila anda sebagai pengguna membuat pembayaran.
                        </li>
                        <li>
                    Pihak Kerajaan Negeri tidak akan bertanggungjawab bagi apa-apa kegagalan oleh semasa membuat pembayaran untuk melindungi data pada skrin daripada dilihat orang lain atau diperolehi oleh mereka yang terbabit, semasa proses pembayaran dalam talian.
                        </li>
                        <li>
                    Pihak Kerajaan Negeri boleh menamatkan akses anda ke mana-mana bahagian perkhidmatan atau keseluruhan perkhidmatan dan mana-mana perkhidmatan yang berkaitan pada bila-bila masa, dengan sebab atau tanpa sebab, dengan notis atau tanpa notis, berkuatkuasa serta merta.
                        </li>
                        <li>
                    Pihak Kerajaan Negeri mempunyai hak pada setiap masa untuk membuat perubahan, pengubahsuaian, pembatalan atau penambahan kepada syarat-syarat ini.
                        </li>
                        <li>
                    Pihak Kerajaan Negeri mempunyai hak pada bila-bila masa dan dari masa ke semasa untuk mengubahsuai atau menamatkan, secara sementara atau tetap, perkhidmatan (atau mana-mana bahagian daripadanya) dengan atau tanpa notis.
                        </li>
                    </ul>

                  </div>
                </div>
              </div>
            </div>
        </div>
        <!--/-->

        <!--
        <div class="row">
            <div class="col-6">
                <ul>
                    <li>Portal e-Services Kedah</li>
                    <li>Berikan Rating</li>
                    <li>Manual Pengguna iBAYAQ</li>
                    <li>Terma &amp; Syarat</li>
                </ul>
            </div>
            <div class="col-6">
                <ul>
                    <li>iDaftar</li>
                    <li>Penafian</li>
                    <li>Imbas QR Code Bil</li>
                    <li>Carian Bil</li>
                </ul>
            </div>
        </div>
        -->

    </div>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialogDasarPrivasi.show = false">Tutup</w-button>
      </template>
</w-dialog>

<w-dialog
    v-model="dialogPautanBerkaitan.show"
    :fullscreen="dialogPautanBerkaitan.fullscreen"
    :width="dialogPautanBerkaitan.width"
    :persistent="dialogPautanBerkaitan.persistent"
    :persistent-no-animation="dialogPautanBerkaitan.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <!-- <w-icon class="mr2">fal fa-pencil</w-icon> -->
      Perkhidmatan Kami
    </template>
    <div class="page-wrapper-portal card-scroll">

        <template v-for="row, index in services">
            <div class="row mt3">
                <div v-for="dt, i in row" class="col-6">
                    <a :href="dt.path" target="_blank"><div 
                        :style="
                        'height: 125px;background: url('+dt.imagepath+') no-repeat center;background-size: cover;'
                        "
                        ></div></a>
                </div>
            </div>
        </template>
        <!-- <div class="row">
            <div class="col-6">
                <a href="https://sppnk.kedah.gov.my/ipinjam/" target="_blank"><div class="pkn-pautan-01"></div></a>
            </div>
            <div class="col-6">
                <a href="https://iservices.kedah.gov.my/" target="_blank"><div class="pkn-pautan-02"></div></a>
            </div>
        </div>

        <div class="row mt3">
            <div class="col-6">
                <a href="https://idaftar.kedah.gov.my/" target="_blank"><div class="pkn-pautan-03"></div></a>
            </div>
            <div class="col-6">
                <a href="https://iforest.kedah.gov.my/" target="_blank"><div class="pkn-pautan-04"></div></a>
            </div>
        </div>

        <div class="row mt3">
            <div class="col-6">
                <a href="https://kedahcare.kedah.gov.my/" target="_blank"><div class="pkn-pautan-05"></div></a>
            </div>
        </div> -->

        <!--
        <div class="row">
            <div class="col-6">
                <ul>
                    <li>Portal e-Services Kedah</li>
                    <li>Berikan Rating</li>
                    <li>Manual Pengguna iBAYAQ</li>
                    <li>Terma &amp; Syarat</li>
                </ul>
            </div>
            <div class="col-6">
                <ul>
                    <li>iDaftar</li>
                    <li>Penafian</li>
                    <li>Imbas QR Code Bil</li>
                    <li>Carian Bil</li>
                </ul>
            </div>
        </div>
        -->

    </div>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialogPautanBerkaitan.show = false">Tutup</w-button>
      </template>
</w-dialog>

<w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-pencil</w-icon>
      Pendaftaran iBayaq
    </template>

    <div class="px-3">
        <div class="auth-logo-box text-center">
            <a href="#" class="logo logo-admin"><img src="assets/images/logo-ibayaq.png" height="100" alt="logo" class="auth-logo"></a>
        </div><!--end auth-logo-box-->

        <div class="text-center auth-logo-text">
            <div class="pkn-pendaftaran-title-1">Pendaftaran Percuma</div>
            <div class="pkn-pendaftaran-title-2">Dapatkan Akaun iBayaq Percuma sekarang.</div>
        </div> <!--end auth-logo-text-->

        <form class="form-horizontal auth-form my-4" action="index.html">

            <div class="form-group mb-3">
                <label for="username" class="form-label">ID Pengguna</label>
                <div class="input-group">
                    <input type="text" class="form-control" id="username" placeholder="Sila masukan ID Pengguna">
                </div>
            </div><!--end form-group-->

            <div class="form-group mb-3">
                <label for="useremail" class="form-label">Email</label>
                <div class="input-group">
                    <input type="email" class="form-control" id="useremail" placeholder="Sila masukan email">
                </div>
            </div><!--end form-group-->

            <div class="form-group mb-3">
                <label for="userpassword" class="form-label">Katalaluan</label>
                <div class="input-group">
                    <input type="password" class="form-control" id="userpassword" placeholder="Sila masukan Katalaluan">
                </div>
            </div><!--end form-group-->

            <div class="form-group mb-3">
                <label for="conf_password" class="form-label">Sah Katalaluan</label>
                <div class="input-group">
                    <input type="password" class="form-control" id="conf_password" placeholder="Sila Sahkan Katalaluan">
                </div>
            </div>

            <div class="form-group mb-3">
                <div class="form-group mb-3">
                    <label for="mo_number" class="form-label">No. Telefon</label>
                    <div class="input-group">
                        <input type="text" class="form-control" id="mo_number" placeholder="Sila masukan No. Telefon">
                    </div>
                </div><!--end form-group-->
            </div><!--end form-group-->

            <div class="form-group row mt-4 pkn-switch">
                <div class="col-sm-12">
                    <div class="custom-control custom-switch switch-success">
                        <input type="checkbox" class="custom-control-input mr3" id="customSwitchSuccess_Signup">
                        <label class="custom-control-label text-muted" for="customSwitchSuccess_Signup">Dengan ini Setuju Dengan <a href="#" class="text-primary">Terma dan Syarat</a></label>
                    </div>
                </div><!--end col-->
            </div><!--end form-group-->


        </form><!--end form-->
    </div>


    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button
      class="ml1"
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        Daftar
      </w-button>
    </template>


  </w-dialog>


</template>
<script type="text/javascript">
    import Swal from 'sweetalert2'

	export default {
	components: {

	},
	setup () {

	},
    props: {
        services: [Array, Object],
    },
	data() {
	    return {
	  no_rujukan: '',
	  senarai : [],
	  total_carian : 0.00,
	  total_pilih : 0.00,
	  cari : {},
	  cari_show : 1,
      berkaitan : 1,
	  form : {},

        dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          item: {name: '', email: '', mobile: ''}
        },

        dialogMengenaiKami: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          item: {name: '', email: '', mobile: ''}
        },
        about_us: '',
        about_us_image: '',

        dialogHubungiKami: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          form: {nama: '', email: ''}
        },

        dialogAduan: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
        },

        dialogPautanBerkaitan: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          item: {name: '', email: '', mobile: ''}
        },

        dialogDasarPrivasi: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          item: {name: '', email: '', mobile: ''}
        },

        validators: {
            required: value => !!value || 'Medan ini wajib diisi',
            email: value => !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) || 'Sila semak format email',
        }

	}},
	methods: {
	  carian () {
	  	var url = window.route('landing.carian')+'?no_rujukan='+this.no_rujukan;
      this.$inertia.visit(url, { preserveScroll : true})
	  },

    pilihBerkaitan(berkaitan){
      this.berkaitan = berkaitan
    },

	  formCari(){
	  	if(this.cari_show == 1){
	  		this.cari_show = 0
	  	}else{
	  		this.cari_show = 1
	  	}

	  },
	  daftar(){
	  	this.dialog.show = 1
	  },

	  hubungiKami(){
	  	this.dialogHubungiKami.show = 1
	  },

      aduan(){
	  	this.dialogAduan.show = 1
	  },

	  mengenaiKami(){
	  	this.dialogMengenaiKami.show = 1
	  },

	  pautanBerkaitan(){
	  	this.dialogPautanBerkaitan.show = 1
	  },

      dasarPrivasi(){
        this.dialogDasarPrivasi.show = 1
      },

	  total(){
	  	 this.total_carian = 0
	  	 this.total_pilih = 0
	  	for (var i in this.senarai) {
	  		if(this.senarai[i].pilih == 1){
	  			this.total_pilih = this.total_pilih + this.senarai[i].amaun
	  		}else{
	  			this.total_carian = this.total_carian + this.senarai[i].amaun
	  		}
	  	}
	  },

    tutup(){
        this.form = {nama: '', email: '', lkp_jabatan_id:'' , lkp_aduan_id:'', keterangan:''}
        this.files = ''
        this.dialogAduan.show = false
    },


      submitAduan(){
        if (this.form.nama != null && this.form.email != null && this.form.keterangan != null && this.form.no_telefon !=null && this.form.lkp_jabatan_id != null && this.form.lkp_aduan_id != null)
        {
          this.form.lkp_aduan_sumber_id = 2
          this.$zcomm.post(this.service_utiliti+'api/aduan/store', this.form)
            .then(res => {
                            if (typeof this.onAfterAdd === "function") {
                                this.onAfterAdd()
                            }
                        this.upload(res.id);
                        })
                        .catch(err => {
                        })
                        .finally(() => {
                                    this.form = {nama: '', email: '', lkp_jabatan_id:'' , lkp_aduan_id:'', keterangan:''}
                                    this.files = ''
                                    this.dialogAduan.show = false
                                    this.$zutil.notify ("Aduan Telah Berjaya Dihantar")

                        })
                        ;
        }
        else {
            Swal.fire({
                                title: 'Ralat!',
                                text: 'Sila Isi Maklumat',
                                icon: 'warning',
                                timer: 60000,
                                showConfirmButton: false,
                                showCloseButton: true,
                            });
        }
        
      },

       upload(id){
            let formData = new FormData();
            formData.append('file', this.files[0].file);
            formData.append('model', 'App\\Models\\Aduan');
            formData.append('model_id', id);
            console.log(formData);
            this.$zcomm.post(this.service_utiliti+'api/aduan/upload', formData)
            .then(res => {
            if (typeof this.onAfterAdd === "function") {
                this.onAfterAdd()
            }
            })
            .catch(err => {

            })
            .finally(() => {

            });
       },


      submit(token) {
            document.getElementById("demo-form").submit();
        },

	  pilih(dt, pilih){
	  	dt.pilih = pilih
	  	this.total()
	  },

      getAbout(){
          axios.post(route('landing.aboutus'))
            .then(res => {
                if(res.data){
                    this.about_us = res.data.content;
                    this.about_us_image = res.data.image;
                }
            })
      }
	},
  mounted() {
    // override default setting

    console.log(this.services);
    console.log('services mana?!!');
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    console.log(this.cari)
    if(this.cari.no_rujukan || this.cari.no_rujukan == ''){
    	this.cari_show = 0
    }else{
    		this.cari_show = 0

    }

    this.getAbout()




  },
}
</script>

<style type="text/css">
    @media only screen and (max-width: 767px) {
    .pkn-carian-landing
        {
            position: inherit !important;
        }
    }
    .trans--bg{
        background-color: #f9f1f14f !important;
    }
</style>
